import { getCurrentLanguage } from "./languageConfig";
import { CHANGE_LANGUAGE } from "../types";

export const changeLanguage = (language) => async (dispatch) => {
  dispatch({
    type: CHANGE_LANGUAGE,
    language: getCurrentLanguage(language),
  });
};
